import {index} from './operations.js';

export default superclass => class extends superclass  {

    onSDFOperationList(operations) {
        // these actually dont need to be uniforms because they are decided
        // on compile time

        this.sdfOperationsList = operations;
        if (this.lastSDFs) {
            this.onSDFList(
                this.lastSDFs,
                true // force recompile
            );
        }
    }

    // these are some bullshit i forget to use...
    dimensionFactors = [];

    onOperation(op) {
        let tokens = op.split(' ');
        let funcName = tokens[0];
        let fn = index[funcName];
        let args = tokens.slice(1).map(x => parseFloat(x));
        if (!fn) {
            return;
        }
        fn(this, ... args);
    }
}
